import { Component, inject, signal } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AuthService } from '../../services/auth.service';
import { RouterModule } from '@angular/router';
import { NavigationComponent } from '../../components/navigation/navigation.component';
import { MatIconModule } from '@angular/material/icon';
import { Location } from '@angular/common';

@Component({
  selector: 'app-auth',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    ReactiveFormsModule,
    RouterModule,
    NavigationComponent,
    MatIconModule,
  ],
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss',
})
export class AuthComponent {
  location: Location = inject(Location);
  private authService = inject(AuthService);
  showRegister: boolean = false;
  $authError = signal('');
  form = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
    officeName: new FormControl(''),
    contactData: new FormControl(''),
  });

  onLogin() {
    console.log('onlogin');

    this.$authError.set('');
    this.form.markAllAsTouched();
    if (
      this.form.controls.email.valid &&
      this.form.controls.password.valid &&
      this.form.controls.email.value !== undefined
    ) {
      // this.authService
      //   .login(this.form.controls.email.value!.toString(), this.form.controls.password.value!.toString())
      //   .catch(error => {
      //     console.log('An error occurred', { ...error });
      //     this.$authError.set(error.code);
      //   });
      this.authService
        .login(this.form.controls.email.value!.toString(), this.form.controls.password.value!.toString())
        .subscribe({
          next: data => {
            console.log('autComp next ', data);
          },
          error: error => {
            console.log('An error occurred', { ...error });
            this.$authError.set(error.code);
          },
        });
    }
  }
}
